import Store from '@/assets/icons/Store.svg';
import Truck from '@/assets/icons/Truck.svg';
import { RadioButtonGroup } from '@/components/RadioButtonGroup';
import { DeliveryOption, ValidationSectionKey } from '@/constants';
import { useCheckout } from '@/contexts/checkoutContext';
import { useShipping } from '@/contexts/shippingContext';
import { useValidation } from '@/contexts/validationContext';
import { useDataLayer } from '@/hooks/useDataLayer';

const deliveryOptionFields = [
  { label: 'Deliver', value: DeliveryOption.Ship, icon: <Truck /> },
  {
    label: 'Click & collect',
    value: DeliveryOption.Collect,
    icon: <Store />,
  },
];

export const DeliveryOptionsToggle = () => {
  const { checkoutData } = useCheckout();
  const { addShippingInfo } = useDataLayer();
  const {
    orderPayload: { deliveryOption },
    setDeliveryOption,
  } = useShipping();

  const { errorMessages, clearValidationError } = useValidation();

  const validationError = errorMessages[ValidationSectionKey.DeliveryOption];

  const handleToggle = (value: string) => {
    if (value === DeliveryOption.Collect || value === DeliveryOption.Ship) {
      setDeliveryOption(value);
      clearValidationError(ValidationSectionKey.DeliveryOption);

      // Track shipping info selection
      const shippingTier = value === DeliveryOption.Collect
        ? 'Click and Collect'
        : 'Delivery';
      addShippingInfo(shippingTier, checkoutData.items || []);
    }
  };

  return (
    <RadioButtonGroup
      className={validationError ? 'has-validation-error' : undefined}
      error={validationError}
      fields={deliveryOptionFields}
      legend="Delivery options"
      name={ValidationSectionKey.DeliveryOption}
      onChange={handleToggle}
      value={deliveryOption}
    />
  );
};
